module.exports = __webpack_public_path__ + "static/media/exams_logo.4f0e7f9f.png";